import {createReducer, createActions} from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  getAllPatientInfoRequest: ['pageNumber', 'timeSlot', 'status' , 'patientType', 'selectedCampaign'],
  getAllPatientInfoSuccess: ['patients', 'pageNumber', 'pageSize'],
  getAllPatientInfoError: ['error'],
  getAllPatientsRequest: ['pageNumber', 'startDate'],
  getAllPatientsRequestError: ['error'],
  getAllPatientsRequestSuccess: ['patients', 'pageNumber', 'pageSize'],
  clearAllPatientsRequest: ['selectedCampaign'],
  clearAllPatientsRequestSuccess: ['success'],
  clearAllPatientsRequestError: ['error'],
});

export const AllPatientTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  error: undefined,
  fetching: false,
  pageNumber: 1,
  pageSize: 5,
  allPatientsCount: 0,
  allPatients: [],
  timeSlot: undefined,
  status: undefined,
  patientType: undefined,
  approvalStatus: undefined,
  success: undefined
});

/* ------------- Reducers ------------- */

export const allPatientsRequest = (state: Object, {request}: Object) => state.merge({
  fetching: true,
  error: undefined
})

export const allPatientsSuccess = (state: Object, {patients, pageNumber, pageSize}: Object) => state.merge({
  fetching: false,
  error: undefined,
  allPatients: patients,
  pageNumber: pageNumber,
  pageSize: pageSize,
  allPatientsCount: patients.totalPatients
})

export const allPatientsError = (state: Object, {error}: Object) => state.merge({
  fetching: false,
  error
})

export const allPatientInfoRequest = (state: Object, request: Object) => {
  let {timeSlot = undefined, patientType = undefined, status = undefined} = request
  timeSlot = timeSlot && timeSlot.length && timeSlot.trim().length ? timeSlot : undefined
  patientType = patientType && !isNaN(patientType) ? patientType : undefined
  status = status && !isNaN(status) ? status : undefined
  return state.merge({
    fetching: true,
    allPatients: undefined,
    error: undefined,
    timeSlot,
    patientType,
    status
  });
}

export const allPatientInfoSuccess = (state: Object, {patients, pageNumber, pageSize}: Object) => {
  return state.merge({
    fetching: false,
    allPatients: patients.patients,
    pageNumber: pageNumber,
    pageSize: pageSize,
    allPatientsCount: patients.totalPatients,
    error: undefined
  });
}

export const allPatientInfoError = (state: Object, {error}: Object) => state.merge({
  fetching: false,
  error
});

export const clearAllPatientsRequest = (state: Object, request: Object) => {
  return state.merge({
    fetching: true,
    allPatients: undefined,
    error: undefined,
    success: undefined,
  });
}

export const clearAllPatientsSuccess = (state: Object, {success}: Object) => {
  return state.merge({
    fetching: false,
    allPatients: undefined,
    pageNumber: 1,
    pageSize: 5,
    allPatientsCount: 0,
    success,
    error: undefined
  });
}

export const clearAllPatientsError = (state: Object, {error}: Object) => state.merge({
  fetching: false,
  error,
  success: undefined,
});

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_ALL_PATIENT_INFO_REQUEST]: allPatientInfoRequest,
  [Types.GET_ALL_PATIENT_INFO_SUCCESS]: allPatientInfoSuccess,
  [Types.GET_ALL_PATIENT_INFO_ERROR]: allPatientInfoError,
  [Types.GET_ALL_PATIENTS_REQUEST]: allPatientsRequest,
  [Types.GET_ALL_PATIENTS_REQUEST_ERROR]: allPatientsError,
  [Types.GET_ALL_PATIENTS_REQUEST_SUCCESS]: allPatientsSuccess,
  [Types.CLEAR_ALL_PATIENTS_REQUEST]: clearAllPatientsRequest,
  [Types.CLEAR_ALL_PATIENTS_REQUEST_ERROR]: clearAllPatientsError,
  [Types.CLEAR_ALL_PATIENTS_REQUEST_SUCCESS]: clearAllPatientsSuccess
});
